/* LINUX — 5.2 image viewer. One dialog for the product gallery and the collection-card zoom.
   window.LinuxViewer.open(items, index, opener, onChange) — items: [{ src, w, h, alt }].
   Shows the whole photo (contain, own ratio), zoom in / out / fit, wheel, double-click, drag,
   pinch, swipe between photos, arrow keys (direction-aware), Esc, focus kept inside, and the
   page scroll position restored on close. */
(() => {
  if (window.LinuxViewer) return;
  const MAX = 5, STEP = 1.6;
  let box, stage, img, counter, items = [], i = 0, opener = null, onChange = null, savedY = 0, hadDrawer = false;
  let s = 1, tx = 0, ty = 0, pinch = null, drag = null;
  const btn = {}, pts = new Map();
  const rtl = () => getComputedStyle(document.documentElement).direction === 'rtl';
  const T = () => (document.documentElement.lang || '').startsWith('ar')
    ? { dialog: 'عارض الصور', close: 'إغلاق', zin: 'تكبير', zout: 'تصغير', reset: 'ملء الشاشة', prev: 'الصورة السابقة', next: 'الصورة التالية' }
    : { dialog: 'Image viewer', close: 'Close', zin: 'Zoom in', zout: 'Zoom out', reset: 'Fit to screen', prev: 'Previous image', next: 'Next image' };
  const ICON = {
    close: '<path d="M6 6l12 12M18 6L6 18"/>',
    zin: '<circle cx="11" cy="11" r="7"/><path d="M11 8v6M8 11h6M20 20l-4-4"/>',
    zout: '<circle cx="11" cy="11" r="7"/><path d="M8 11h6M20 20l-4-4"/>',
    reset: '<path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/>',
    prev: '<path d="M15 6l-6 6 6 6"/>', next: '<path d="M9 6l6 6-6 6"/>',
  };
  const svg = (d) => `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${d}</svg>`;

  function build() {
    const t = T();
    box = document.createElement('div');
    box.className = 'zoombox';
    box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', t.dialog); box.setAttribute('aria-hidden', 'true'); box.inert = true;
    const b = (k, cls = '') => `<button class="zoombox__btn ${cls}" type="button" data-zb="${k}" aria-label="${t[k]}" title="${t[k]}">${svg(ICON[k])}</button>`;
    box.innerHTML = `<div class="zoombox__bar"><span class="zoombox__count" aria-live="polite"></span><div class="zoombox__tools">${b('zout')}${b('reset')}${b('zin')}${b('close', 'zoombox__close')}</div></div>`
      + '<div class="zoombox__stage"><img class="zoombox__img" alt="" decoding="async" draggable="false"></div>'
      + b('prev', 'zoombox__nav zoombox__nav--prev') + b('next', 'zoombox__nav zoombox__nav--next');
    stage = box.querySelector('.zoombox__stage'); img = box.querySelector('.zoombox__img'); counter = box.querySelector('.zoombox__count');
    box.querySelectorAll('[data-zb]').forEach((el) => { btn[el.dataset.zb] = el; });
    box.addEventListener('click', (e) => {
      const k = e.target.closest('[data-zb]')?.dataset.zb;
      if (k === 'close') close(); else if (k === 'zin') zoomTo(s * STEP); else if (k === 'zout') zoomTo(s / STEP);
      else if (k === 'reset') reset(); else if (k === 'prev') go(-1); else if (k === 'next') go(1);
    });
    stage.addEventListener('wheel', (e) => { e.preventDefault(); zoomTo(s * (e.deltaY < 0 ? 1.15 : 1 / 1.15), e.clientX, e.clientY); }, { passive: false });
    stage.addEventListener('dblclick', (e) => { if (s > 1.01) reset(); else zoomTo(2.5, e.clientX, e.clientY); });
    stage.addEventListener('pointerdown', down);
    stage.addEventListener('pointermove', move);
    stage.addEventListener('pointerup', up);
    stage.addEventListener('pointercancel', up);
    img.addEventListener('load', () => { img.classList.add('is-ready'); apply(); });
    img.addEventListener('error', () => img.classList.add('is-ready'));
    document.body.append(box);
  }

  function clamp() {
    if (s <= 1.001) { s = 1; tx = 0; ty = 0; return; }
    const mx = Math.max(0, (img.offsetWidth * s - stage.clientWidth) / 2), my = Math.max(0, (img.offsetHeight * s - stage.clientHeight) / 2);
    tx = Math.max(-mx, Math.min(mx, tx)); ty = Math.max(-my, Math.min(my, ty));
  }
  function apply() {
    clamp();
    img.style.transform = `translate3d(${tx}px, ${ty}px, 0) scale(${s})`;
    box.classList.toggle('is-zoomed', s > 1.01);
    btn.zout.setAttribute('aria-disabled', String(s <= 1.01));
    btn.reset.setAttribute('aria-disabled', String(s <= 1.01));
    btn.zin.setAttribute('aria-disabled', String(s >= MAX - 0.01));
  }
  function zoomTo(ns, cx, cy) {
    ns = Math.max(1, Math.min(MAX, ns));
    const r = stage.getBoundingClientRect(), ox = r.left + r.width / 2, oy = r.top + r.height / 2;
    const px = (cx ?? ox) - ox, py = (cy ?? oy) - oy;
    tx = px - (px - tx) * (ns / s); ty = py - (py - ty) * (ns / s); s = ns;
    apply();
  }
  const reset = () => { s = 1; tx = 0; ty = 0; apply(); };

  function down(e) {
    stage.setPointerCapture?.(e.pointerId);
    pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (pts.size === 2) { const [a, c] = [...pts.values()]; pinch = { d: Math.hypot(a.x - c.x, a.y - c.y) || 1, s }; drag = null; }
    else if (pts.size === 1) drag = { x: e.clientX, y: e.clientY, tx, ty, t: Date.now(), onImg: e.target === img };
  }
  function move(e) {
    if (!pts.has(e.pointerId)) return;
    pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (pinch && pts.size === 2) { const [a, c] = [...pts.values()]; zoomTo(pinch.s * Math.hypot(a.x - c.x, a.y - c.y) / pinch.d, (a.x + c.x) / 2, (a.y + c.y) / 2); return; }
    if (drag && s > 1.01) { tx = drag.tx + e.clientX - drag.x; ty = drag.ty + e.clientY - drag.y; apply(); }
  }
  function up(e) {
    if (!pts.has(e.pointerId)) return;
    pts.delete(e.pointerId);
    if (pts.size < 2) pinch = null;
    if (drag && pts.size === 0) {
      const dx = e.clientX - drag.x, dy = e.clientY - drag.y, dt = Date.now() - drag.t;
      if (s <= 1.01) {
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.2) go((dx < 0) !== rtl() ? 1 : -1);
        else if (dy > 90 && dy > Math.abs(dx)) close();
        else if (!drag.onImg && Math.abs(dx) < 6 && Math.abs(dy) < 6 && dt < 400) close();
      }
      drag = null;
    }
  }

  function show(n) {
    i = (n + items.length) % items.length;
    const it = items[i];
    s = 1; tx = 0; ty = 0;
    img.classList.remove('is-ready'); img.removeAttribute('src');
    if (it.w && it.h) { img.width = it.w; img.height = it.h; } else { img.removeAttribute('width'); img.removeAttribute('height'); }
    img.alt = it.alt || '';
    img.src = it.src;
    const many = items.length > 1;
    counter.textContent = many ? `${i + 1} / ${items.length}` : '';
    btn.prev.hidden = !many; btn.next.hidden = !many;
    apply();
    onChange?.(i);
  }
  const go = (d) => { if (items.length > 1) show(i + d); };

  function open(list, index = 0, from = null, cb = null) {
    list = (list || []).filter((x) => x && x.src);
    if (!list.length) return;
    if (!box) build();
    const already = box.classList.contains('is-open');
    items = list; opener = from || document.activeElement; onChange = cb;
    if (!already) {
      savedY = window.scrollY;
      hadDrawer = document.body.classList.contains('drawer-open');
      document.documentElement.classList.add('zoombox-lock');
      document.body.classList.add('drawer-open');
    }
    show(Math.max(0, Math.min(items.length - 1, index | 0)));
    box.classList.add('is-open'); box.setAttribute('aria-hidden', 'false'); box.inert = false;
    btn.close.focus({ preventScroll: true });
  }
  function close() {
    if (!box?.classList.contains('is-open')) return;
    box.classList.remove('is-open'); box.setAttribute('aria-hidden', 'true'); box.inert = true;
    pts.clear(); pinch = null; drag = null;
    document.documentElement.classList.remove('zoombox-lock');
    if (!hadDrawer) document.body.classList.remove('drawer-open');
    if (Math.abs(window.scrollY - savedY) > 1) window.scrollTo(0, savedY);
    opener?.focus?.({ preventScroll: true });
    opener = null; onChange = null;
  }

  document.addEventListener('keydown', (e) => {
    if (!box?.classList.contains('is-open')) return;
    const k = e.key;
    let handled = true;
    if (k === 'Escape') close();
    else if (k === 'ArrowRight' || k === 'ArrowLeft') go((k === 'ArrowRight') !== rtl() ? 1 : -1);
    else if (k === '+' || k === '=') zoomTo(s * STEP);
    else if (k === '-') zoomTo(s / STEP);
    else if (k === '0') reset();
    else if (k === 'Tab') {
      const f = [...box.querySelectorAll('button:not([hidden])')], a = f.indexOf(document.activeElement);
      if (e.shiftKey ? a <= 0 : a === f.length - 1) f[e.shiftKey ? f.length - 1 : 0].focus(); else handled = false;
    } else handled = false;
    if (handled) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  addEventListener('resize', () => { if (box?.classList.contains('is-open')) apply(); });

  /* Collection cards: [data-card-zoom="<url>"] with data-w / data-h / data-alt */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-card-zoom]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    open([{ src: b.dataset.cardZoom, w: Number(b.dataset.w) || 0, h: Number(b.dataset.h) || 0, alt: b.dataset.alt || '' }], 0, b);
  });

  window.LinuxViewer = { open, close };
})();